<div fxLayout="row" fxLayoutAlign="start center">
    <h4 class="mat-color-text--grey-700" fxFlex *ngIf="(_data.view !=''); else elseBlock">{{_data.view}}</h4>
    <ng-template #elseBlock>Audit Log</ng-template>
    <button mat-icon-button color="primary" (click)="onClickCancel()">
        <mat-icon>clear</mat-icon>
    </button>
</div>

<mat-divider></mat-divider>

<div *ngIf="_matColumns">
    <h6 *ngIf="!_data">No audit logs found! </h6>
    <app-basic-table [tableData]="_data" [columnHeaders]="this._matColumns"></app-basic-table>
</div>

<div *ngIf="!_mColumns && !_matColumns" fxLayout="row">
    <mat-accordion displayMode="flat" class="mat-table">
        <section matSort class="mat-elevation-z2 mat-header-row">
            <span class="mat-header-cell">UpdatedBy Name</span>
            <span class="mat-header-cell">UpdatedById</span>
            <span class="mat-header-cell">Update DateTime</span>
            <span class="mat-header-cell">TripCode </span>
            <span class="mat-header-cell">TripDate</span>
            <span class="mat-header-cell">Trip Distance</span>
            <span class="mat-header-cell">Trip TravelTime</span>
            <span class="mat-header-cell">Escort Status </span>
            <span class="mat-header-cell">SiteName</span>
            <span class="mat-header-cell">Shift Time</span>
            <span class="mat-header-cell">Vendor name</span>
            <span class="mat-header-cell">VehicleNo </span>
            <span class="mat-header-cell">Driver Name</span>
            <span class="mat-header-cell">Escort Name</span>
            <span class="mat-header-cell">TripStatus </span>
        </section>

        <mat-expansion-panel #mep="matExpansionPanel" [disabled]="false" [expanded]="allExpandState" *ngFor="let trip of _data let
        i=index;">
            <mat-expansion-panel-header class="mat-row">
                <span class="mat-cell"> {{trip.updatedByName}}</span>
                <span class="mat-cell">{{trip.updatedByEmpCode}}</span>
                <span class="mat-cell">{{trip.updatedDate}}</span>
                <span class="mat-cell">{{trip.tripCode}}</span>
                <span class="mat-cell"> {{trip.tripDate}}</span>
                <span class="mat-cell">{{trip.tripDistance}}</span>
                <span class="mat-cell">{{trip.tripTravelTime}}</span>
                <span class="mat-cell">{{trip.escortStatus}}</span>
                <span class="mat-cell"> {{trip.siteName}}</span>
                <span class="mat-cell">{{trip.shiftTime}}</span>
                <span class="mat-cell">{{trip.vendorName}}</span>
                <span class="mat-cell">{{trip.vehicleNo}}</span>
                <span class="mat-cell"> {{trip.driverName}}</span>
                <span class="mat-cell">{{trip.escortName}}</span>
                <span class="mat-cell">{{trip.tripStatus}}</span>
            </mat-expansion-panel-header>
            <mat-accordion displayMode="flat" class="mat-table">
                <div *ngIf="trip.tripUserList.length > 0 ">
                    <div class="tdw-padding-v-4"></div>
                    <table class="customers">
                        <tr>
                            <th>Updated DateTime</th>
                            <th>EmployeeId</th>
                            <th>EmployeeName</th>
                            <th>RoutedOrder</th>
                            <th>ShowStatus</th>
                            <th>CurrentStatus</th>
                            <th>PickUp-Drop Time</th>
                        </tr>
                        <tr *ngFor="let tripUser of trip.tripUserList">
                            <td>{{tripUser.updatedTime}}</td>
                            <td>{{tripUser.employeeId}}</td>
                            <td>{{tripUser.employeeName}}</td>
                            <td>{{tripUser.routedOrder}}</td>
                            <td>{{tripUser.showStatus}}</td>
                            <td>{{tripUser.currentStatus}}</td>
                            <td>{{tripUser.pickUpDropTime}}</td>
                        </tr>
                    </table>
                </div>
                <div *ngIf="trip.tripUserList.length == 0">
                    No data found
                </div>
            </mat-accordion>
        </mat-expansion-panel>
    </mat-accordion>
</div>

<div *ngIf="_mColumns" fxLayout="row">
    <mat-accordion displayMode="flat" class="mat-table">
        <div style="width: 785px;">
            <div fxLayout="row">
                <mat-accordion displayMode="flat" class="mat-table">
                    <section matSort class="mat-elevation-z2 mat-header-row">
                        <span class="mat-header-cell">Updated By EmpId</span>
                        <span class="mat-header-cell">Employee Role</span>
                        <span class="mat-header-cell">Updated By EmpName</span>
                        <span class="mat-header-cell">Updated DateTime</span>
                        <span class="mat-header-cell">Action</span>
                    </section>

                    <mat-expansion-panel #mep="matExpansionPanel" [disabled]="false" (click)="open(trip)"
                        [expanded]="allExpandState" *ngFor="let trip of _commondata let i=index;">

                        <mat-expansion-panel-header class="mat-row">
                            <span class="mat-cell">{{trip.updatedByEmpID}}</span>
                            <span class="mat-cell">{{trip.EmployeeRole}}</span>
                            <span class="mat-cell">{{trip.updatedBy}}</span>
                            <span class="mat-cell">{{trip.updatedDate | date : "EEE MMM-dd-yyyy h:mm a"}}</span>
                            <span class="mat-cell">{{trip.revisionType}}</span>
                        </mat-expansion-panel-header>

                        <mat-accordion displayMode="flat" class="mat-table">
                            <div *ngIf="templateflag">
                                <table class="customers">
                                    <tr>
                                        <th>FieldName</th>
                                        <th>OldValues</th>
                                        <th>NewValues</th>
                                    </tr>
                                    <tr *ngFor="let val of modelAudits">
                                        <td> {{val.fieldNames}} </td>
                                        <td> {{val.oldValues}} </td>
                                        <td> {{val.newValues}} </td>
                                    </tr>
                                </table>
                            </div>
                            <div *ngIf="modelAudits.length == 0">
                                No data found
                            </div>
                        </mat-accordion>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
    </mat-accordion>
</div>